(function () {
    'use strict';

    angular
        .module('Lavpop-store.services')
        .service('MeService', MeService)

    /** @ngInject */
    function MeService($http, $httpParamSerializerJQLike, HttpService, ROUTES) {
        const MeService = {
            getMe: getMe,
            refreshToken: refreshToken
        }

        return MeService;

        function getMe() {
            return HttpService.get('/me');
        }

        function refreshToken(refreshToken, tokenOwner) {
            const loginData = {
                refresh_token: refreshToken,
                grant_type: 'refresh_token',
                client_id: tokenOwner
            };

            return $http.post(
                `${ROUTES.SSO_API}authorization`,
                $httpParamSerializerJQLike(loginData),
                {
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded'
                    }
                }
            );
        }
    }
}());